/* 🤖 this file was generated by svg-to-ts */
export const DfIconQuestionMark16: {
  name: 'question-mark-16';
  data: string;
} = {
  name: 'question-mark-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0-4A1.5 1.5 0 0 1 6 9.5c0-2.083 3.494-3.007 3.494-5C9.494 3.526 8.76 3 8 3c-.747 0-1.503.498-1.503 1.997H4C4 2.5 5.733 1 8 1s4 1.368 4 3.5c0 2.755-3.002 3.003-3.002 5v.002c0 .827-.67 1.498-1.498 1.498z" fill-rule="evenodd"/></svg>`
};
